import { useState } from 'react';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import keys from 'ramda/src/keys';
import path from 'ramda/src/path';
import Pagination from '@components/@core/Pagination';
import Rating from '@components/@core/Rating';
import { inPage } from '~/services/util';
import { ListHeader as ExpandedListHeader, EmployeeItem } from './EmployeeList';

const ListHeader = () => (
    <div className="vdmm-cp-header d-flex pb-3 desktop-flex">
        <div className="d-flex-4 me-3 me-md-0">
            <span className="dsl-m12">Departments</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Teams</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Employees</span>
        </div>
        <div className="d-flex-3 text-start">
            <span className="dsl-m12">Completed</span>
        </div>
        <div className="d-flex-3">
            <span className="dsl-m12">Score</span>
        </div>
    </div>
);

const OrgChartEmployeeReport = ({ companyId, data, dateStart, dateEnd, onColumn, onReport, onRowClick, onSelectMenu, onScorecardDetail }) => {
    const dgroups = companyId.map((id) => path(['companies', id], data));

    return dgroups.map((group) => {
        if (!group?.departments) return null;
        const { departments } = group;

        return (
            <div key={group.id} className="orgchart-section">
                <p className="dsl-b14 text-500 mb-2">{group.name}</p>
                <ListHeader />
                <Accordion className="department-accordion" allowMultipleExpanded allowZeroExpanded>
                    {keys(departments).map((key, index) => {
                        const { totals, users } = departments[key];
                        const [page, setPage] = useState(1);
                        const [per, setPer] = useState(25);

                        const handleChange = (e) => {
                            setPage(e);
                            onColumn(key, e, per);
                        };

                        const handlePer = (e) => {
                            setPer(e);
                            onColumn(key, page, e);
                        };

                        return (
                            <AccordionItem key={`orgchart-${index}`}>
                                <AccordionItemHeading onClick={() => onColumn(key, page, per)}>
                                    <AccordionItemButton>
                                        <div className="d-flex-4 orgchart-name me-3 me-md-0">
                                            <span className="dsl-b14 ms-3 float-left">{key}</span>
                                        </div>
                                        <div className="d-flex-2 d-flex ssm-column">
                                            <label className="dsl-b14 w-50 me-2">{totals?.teams ?? 0}</label>
                                        </div>
                                        <div className="d-flex-2 d-flex ssm-column">
                                            <label className="dsl-b14 w-50 me-2">{totals?.total_users ?? 0}</label>
                                        </div>
                                        <div className="d-flex-3 d-flex ssm-column">
                                            <label className="dsl-b14 w-50 me-2">{totals?.reviews_completed ?? 0}</label>
                                        </div>
                                        <div className="d-flex-3 d-flex ssm-column ms-n5">
                                            {totals?.reviews_completed > 0 ? <Rating score={totals?.completed_average_star_rating ?? 0} /> : <label className="dsl-b14 w-100 me-2">Incomplete</label>}
                                        </div>
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                {users?.length > 0 && (
                                    <AccordionItemPanel className="accordion__panel px-0">
                                        <ExpandedListHeader />
                                        {users.map(
                                            (item, index) =>
                                                inPage(index, page, per) && (
                                                    <EmployeeItem
                                                        key={index}
                                                        item={{
                                                            user: item,
                                                            performance: item.performance,
                                                            scorecards: item.scorecard ? [item.scorecard] : [],
                                                        }}
                                                        dateStart={dateStart}
                                                        dateEnd={dateEnd}
                                                        onReport={onReport}
                                                        onRowClick={onRowClick}
                                                        onSelectMenu={onSelectMenu}
                                                        onScorecardDetail={onScorecardDetail}
                                                    />
                                                )
                                        )}
                                        <Pagination current={page} total={Math.ceil(users?.length / per)} per={per} onChange={handleChange} onPer={handlePer} />
                                    </AccordionItemPanel>
                                )}
                            </AccordionItem>
                        );
                    })}
                </Accordion>
            </div>
        );
    });
};

export default OrgChartEmployeeReport;
